import React from 'react';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Departamento from 'Interface/Departamentos';
import { useEditarDepartamentoMutation } from 'View/Service/Default/Departamentos';

interface Props {
    dados: Departamento;
    acoes?: boolean;
}

const Lista = ({dados, acoes = true}: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ editarDepartamento ] = useEditarDepartamentoMutation();

    const remover = async (): Promise<void> =>
    {
        try {
            await editarDepartamento({ id: dados.id, ativo: 0 }).unwrap();

            toast({
                conteudo: 'Removido com sucesso!',
                tema: 'success',
            });
        } catch (erro) {
            toast({
                titulo: 'Erro ao remover',
                conteudo: 'Verifique o registro de log para mais detalhes!',
                tema: 'danger',
            });
        }
    }

    return (
        <div
            key={dados.nome}
            className="d-flex border-bottom align-items-center py-2 px-3"
        >
            <div className="fs-4">
                <Link to={`/departamentos/editar/${dados.id}`} className="text-decoration-none">
                    {dados.nome}
                </Link>
                <small className="text-muted fs-6 d-block">
                    Gerente: { dados.usuario ? dados.usuario.nome : 'Nenhum atribuido' }
                </small>
            </div>
            <div className="ms-5 fs-5 flex-grow-1 text-end">
                {acoes && (
                    <Botao
                        icone="trash"
                        tema="danger"
                        className="ms-5"
                        confirmacao="Você tem certeza que deseja remover esse departamento? Essa ação é irreversivel."
                        onClick={ remover }
                    />
                )}
            </div>
        </div>
    )
}

export default Lista;
